<div class="mission-performance-container">
  <app-analytics-card [title]="'ANALYTICS.TOTAL_WAREHOUSE_OPERATIONS' | translate">
    <app-analytics-widget [query]="'mission-analytics'" [filters]="filters">
      <ng-template let-result>
        @if (result && result.rows && result.rows.length) {
          <div class="mission-analytics-container">
            <div class="total-mission-card">
              <app-icam-icon iconName="total-mission" iconHeight="100%" />
              <span class="label">{{ 'ANALYTICS.TOTAL_MISSIONS' | translate }}</span>
              <span class="value">{{ result.rows[0].mission_count }}</span>
            </div>
            <app-divider [orientation]="'vertical'" />
            <app-analytics-widget [query]="'mission-analytics'" [centered]="true" [filters]="pickingFilters">
              <ng-template let-result>
                @if (result && result.rows && result.rows.length) {
                  <div class="mission-data-card-container">
                    <div class="mission-data-card">
                      <app-icam-icon iconName="picking-mission" iconHeight="100%" />
                      <div class="info">
                        <span class="label">{{ 'ANALYTICS.PICKING_MISSIONS' | translate }}</span>
                        <span class="value">{{ result.rows[0].mission_count }}</span>
                      </div>
                    </div>
                    <div class="mission-data-card">
                      <app-icam-icon iconName="avg-picking-time" iconHeight="100%" />
                      <div class="info">
                        <span class="label">{{ 'ANALYTICS.AVG_PICKING_TIME' | translate }}</span>
                        <span class="value">{{ formatMs(result.rows[0].avg_mission_time) }}</span>
                      </div>
                    </div>
                  </div>
                }
              </ng-template>
            </app-analytics-widget>
            <app-divider [orientation]="'vertical'" />
            <app-analytics-widget [query]="'mission-analytics'" [centered]="true" [filters]="refillingFilters">
              <ng-template let-result>
                @if (result && result.rows && result.rows.length) {
                  <div class="mission-data-card-container">
                    <div class="mission-data-card">
                      <app-icam-icon iconName="refilling-mission" iconHeight="100%" />
                      <div class="info">
                        <span class="label">{{ 'ANALYTICS.REFILLING_MISSIONS' | translate }}</span>
                        <span class="value">{{ result.rows[0].mission_count }}</span>
                      </div>
                    </div>
                    <div class="mission-data-card">
                      <app-icam-icon iconName="avg-refilling-time" iconHeight="100%" />
                      <div class="info">
                        <span class="label">{{ 'ANALYTICS.AVG_REFILLING_TIME' | translate }}</span>
                        <span class="value">{{ formatMs(result.rows[0].avg_mission_time) }}</span>
                      </div>
                    </div>
                  </div>
                }
              </ng-template>
            </app-analytics-widget>
          </div>
        }
      </ng-template>
    </app-analytics-widget>
  </app-analytics-card>

  <app-analytics-card [title]="'ANALYTICS.TREND_PICKING_REFILLING' | translate">
    <div class="chart-header">
      <div class="chart-controls">
        <div
          class="chart-dataset-toggle picking"
          role="button"
          (click)="togglePickingDataset()"
          (keydown.enter)="togglePickingDataset()"
          tabindex="0"
        >
          <div class="color"></div>
          <span>{{ 'ANALYTICS.PICKING_OPERATIONS' | translate }}</span>
        </div>

        <div
          class="chart-dataset-toggle refilling"
          role="button"
          (click)="toggleRefillingDataset()"
          (keydown.enter)="toggleRefillingDataset()"
          tabindex="0"
        >
          <div class="color"></div>
          <span>{{ 'ANALYTICS.REFILLING_OPERATIONS' | translate }}</span>
        </div>
      </div>

      <div class="chart-group-select">
        <label for="group-select">{{ 'ANALYTICS.GROUP_BY' | translate }}</label>
        <select id="group-select" #groupSelect (change)="onGroupChange(groupSelect.value)">
          <option value="day" [selected]="selectedGroup === 'day'">{{ 'ANALYTICS.DAY' | translate }}</option>
          <option value="month" [selected]="selectedGroup === 'month'">{{ 'ANALYTICS.MONTH' | translate }}</option>
          <option value="year" [selected]="selectedGroup === 'year'">{{ 'ANALYTICS.YEAR' | translate }}</option>
        </select>
      </div>
    </div>

    <app-analytics-widget [query]="'mission-grouped'" [filters]="pickingFilters">
      <ng-template let-pickingResult>
        <app-analytics-widget [query]="'mission-grouped'" [filters]="refillingFilters">
          <ng-template let-refillingResult>
            <div class="chart-wrapper">
              <app-analytics-chart
                #missionChart
                [analyticsResults]="[pickingResult, refillingResult]"
                [resultsLabelsKey]="resultsLabelsKey"
                [resultsValueKey]="'mission_count'"
                [datasetLabels]="['Picking', 'Refilling']"
                chartType="line"
                [colors]="['#E74C3C', '#00ABB0']"
                [showLegend]="false"
              ></app-analytics-chart>
            </div>
          </ng-template>
        </app-analytics-widget>
      </ng-template>
    </app-analytics-widget>
  </app-analytics-card>
</div>
